import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController, LoadingController } from 'ionic-angular';

import { Task, User } from '@providers/index';
import { FormTaskPage, DetailTaskPage } from '../'

@Component({
  selector: 'page-task',
  templateUrl: 'page.html'
})
export class TaskPage {

  listTask : any ;
  project:any = {};
  loading:any;
  
  //akses fitur
  can_edit=false;
  view_sbp=false;

  constructor(
    public navCtrl     : NavController,
    public navParams   : NavParams,
    private alertCtrl  : AlertController,
    private toastCtrl  : ToastController,
    public loadingCtrl : LoadingController,
    public taskApi     : Task,
    public userApi     : User
  ) {
    
    this.project = this.navParams.get('project');

    if(this.userApi.akses.edit_project_group_data=='branch'){
      if(this.project.branch_id == this.userApi.group.user_data){
        this.can_edit=true;
      }
    }else if(this.userApi.akses.edit_project_group_data=='all'){
      this.can_edit = true;
    }else if(this.userApi.akses.edit_project_group_data=='mine'){
      if(this.project.created_by == this.userApi.data.employee_id){
        this.can_edit=true;
      }
    }

  }
  
  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  ionViewWillEnter(){
    this.getList();
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getList();
  }

  getList(){
    this.showLoading();
    let params = {
      project_id : this.project.id
    }
    this.taskApi.get(params).subscribe((resp:any) => {
      this.listTask = resp.data;
      this.loading.dismiss();
    });
  }

  add(){
    this.navCtrl.push(FormTaskPage, {
      project : this.project
    })
  }

  edit(rec) {
    this.navCtrl.push(FormTaskPage, {
      project: this.project,
      rec:rec
    });
  }

  detail(rec) {
    this.navCtrl.push(DetailTaskPage, {
      project: this.project,
      rec:rec
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/project_mobile/task/page.ts